import * as React from 'react';
import { Card, DatePicker, Switch, Typography } from '@symphony-ui/uitoolkit-components';
import SelectionStatus from '@symphony-ui/uitoolkit-components/components/selection/SelectionStatus';
import DownloadContext from 'contexts/DownloadContext';
import ApiServerRequest from 'models/ApiServerRequest';
import { sendFetchError } from 'utils/messageUtils';
import KeyFormModal from '../regexes/key-form-modal/KeyFormModal';
import RegexFormModal from '../regexes/regex-modal/RegexFormModal';
import ToDoTable from './TodDoTable';
import ApiServerURL from 'models/ApiServerUrl';
import { datePattern } from 'components/custom-table/dateFormat';
const ToDo = () => {
    const { apiFetchJson } = React.useContext(DownloadContext);
    const [hasError, setError] = React.useState(false);
    const [isLoading, setLoading] = React.useState(false);
    const [name, setName] = React.useState();
    const [originalRegex, setOriginalRegex] = React.useState();
    const [regex, setRegex] = React.useState();
    const [title, setTitle] = React.useState('');
    const [showKey, setShowKey] = React.useState(false);
    const [showRegex, setShowRegex] = React.useState(false);
    const [type, setType] = React.useState('keyvalues');
    const [viewAll, setViewAll] = React.useState(true);
    const [toDo, setToDo] = React.useState([]);
    const [date, setDate] = React.useState();
    const onChangeDate = React.useCallback((event) => {
        setDate(event.target.value);
    }, []);
    React.useEffect(() => {
        const abortController = new AbortController();
        setLoading(true);
        const url = new ApiServerURL('/syndicate/regex/keyvalues/to-do');
        if (date !== undefined) {
            url.searchParams.append('from', date.toISOString());
        }
        const request = new ApiServerRequest(url);
        (async () => {
            try {
                const body = await apiFetchJson(request, abortController.signal);
                setToDo(body);
            }
            catch (error) {
                if (!(error instanceof Error && error.name === 'AbortError')) {
                    sendFetchError('Unable to download to do list', error, request);
                    setError(true);
                }
            }
            finally {
                setLoading(false);
            }
        })();
        return () => abortController.abort();
    }, [apiFetchJson, date]);
    const data = React.useMemo(() => toDo.filter((t) => viewAll || (!t.known || !t.parsable)), [toDo, viewAll]);
    return (React.createElement(Card, { className: "co-card-main admin" },
        showKey ?
            React.createElement(KeyFormModal, { hideModal: () => setShowKey(false), name: name, title: title }) : undefined,
        showRegex ?
            React.createElement(RegexFormModal, { callback: () => document.dispatchEvent(new Event('reloadcontent')), hideModal: () => setShowRegex(false), originalRegex: originalRegex, regex: regex, title: title, type: type }) : undefined,
        React.createElement("div", { className: "co-header-main" },
            React.createElement(Typography, { type: "h1" }, "Regex To Do List")),
        React.createElement(ToDoTable, { actionElements: [
                (React.createElement("div", { key: 'from', style: { marginRight: '1rem' } },
                    React.createElement(DatePicker, { date: date, disabledDays: [{ before: new Date(2022, 1, 17) }, { after: new Date() }], format: datePattern(), label: "Restrict to data from", onChange: onChangeDate }))),
                React.createElement("div", { key: 'all', style: { alignSelf: 'end' } },
                    React.createElement(Switch, { label: "View all", name: "switch", onChange: () => setViewAll(!viewAll), status: viewAll ? SelectionStatus.SWITCHED : SelectionStatus.UNSWITCHED, value: viewAll ? 'true' : 'false' }))
            ], data: data, hasError: hasError, isLoading: isLoading, setName: setName, setOriginalRegex: setOriginalRegex, setRegex: setRegex, setShowKey: setShowKey, setShowRegex: setShowRegex, setTitle: setTitle, setType: setType })));
};
export default ToDo;
